import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export const useApiToast = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const showSuccess = (messageKey: string, namespace = 'common') => {
    enqueueSnackbar(t(`${namespace}:${messageKey}`), {
      variant: 'success'
    });
  };

  const showError = (
    messageKey: string,
    error?: unknown,
    namespace = 'common'
  ) => {
    const errorMessage =
      error instanceof Error ? error.message : String(error || '');
    const fullMessage = errorMessage
      ? `${t(`${namespace}:${messageKey}`)}: ${errorMessage}`
      : t(`${namespace}:${messageKey}`);

    enqueueSnackbar(fullMessage, {
      variant: 'error'
    });
  };

  const showWarning = (messageKey: string, namespace = 'common') => {
    enqueueSnackbar(t(`${namespace}:${messageKey}`), {
      variant: 'warning'
    });
  };

  const showInfo = (messageKey: string, namespace = 'common') => {
    enqueueSnackbar(t(`${namespace}:${messageKey}`), {
      variant: 'info'
    });
  };

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};
